import { SpeechConfig, AudioConfig } from 'microsoft-cognitiveservices-speech-sdk';
class SpeechService {
    constructor() {
        this.speechConfig = SpeechConfig.fromSubscription('b5eb1b28954e4c08a57f13b2f4a4b16e', 'eastasia');
        this.speechConfig.speechRecognitionLanguage = 'zh-CN';
        this.audioConfig = AudioConfig.fromDefaultMicrophoneInput();
    }
}
export const speechService = new SpeechService();
